'use client';

import styles from './policy.module.css';


export default function PrivacyPolicyPage() {
  
  return (
          <div className={styles.pageWrapper}>
      <h1 className={styles.title}>Privacy Policy</h1>
      <p className={styles.updated}>Last updated: October 2025</p>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>1. Introduction</h2>
        <p className={styles.sectionText}>
          This Privacy Policy explains how <strong>Mira Classical</strong> collects, uses, and protects your personal information when you use our service.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>2. Information We Collect</h2>
        <p className={styles.sectionText}>
          We collect information necessary to provide and personalize the service, including:
        </p>
        <ul className={styles.sectionList}>
          <li>Account information (such as your name, email, and login provider)</li>
          <li>Your activity in Mira Classical (listening history, playlists you create, and favorites you add)</li>
          <li>Technical information (such as device information, system configuration, and identifiers used to ensure security and improve the service)</li>
        </ul>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>3. How We Use Information</h2>
        <p className={styles.sectionText}>
          We use your information to deliver personalized recommendations, maintain your playlists and favorites, improve the service, and ensure security.
          Your activity helps us tailor Mira Classical to your preferences and provide a better experience.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>4. Data Retention & Security</h2>
        <p className={styles.sectionText}>
          We retain your listening history, favorites, and playlists for as long as you maintain an active account.
          These records are essential for providing personalized recommendations and ensuring the service functions as intended.
          You may delete your history, favorites, playlists, or your entire account at any time, which will remove or anonymize the associated data.
        </p>
        <p className={styles.sectionText}>
          We protect your information using industry‑standard safeguards, including encryption during transmission and secure storage.
          Access to personal data is restricted to authorized personnel and monitored through audit logs.
          Backup copies are securely maintained and tested regularly to ensure recovery integrity.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>5. Legal Basis for Processing</h2>
        <p className={styles.sectionText}>
          We process your personal data on the legal basis of contract performance (providing the Mira Classical service)
          and compliance with legal obligations. We do not rely on consent for essential cookies or data required to deliver the service.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>6. Your Rights</h2>
        <p className={styles.sectionText}>
          You have the right to access, correct, delete, or export your personal data at any time.
          You may also request restriction of processing where applicable.
          If you delete your account, all associated data will be removed or anonymized.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>7. Data Transfers</h2>
        <p className={styles.sectionText}>
          If your data is transferred outside the European Union, we ensure adequate safeguards such as encryption
          and contractual commitments to protect your information.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>8. Contact Information</h2>
        <p className={styles.sectionText}>
          For any questions or requests regarding your personal data, please contact us at
          <a href="mailto:privacy@miraclassical.com" className={styles.link}> privacy@miraclassical.com</a>.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>9. Supervisory Authority</h2>
        <p className={styles.sectionText}>
          You have the right to lodge a complaint with your local Data Protection Authority if you believe your rights have been violated.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>10. Updates to This Policy</h2>
        <p className={styles.sectionText}>
          We may update this Privacy Policy from time to time to reflect changes in technology,
          legal requirements, or our services. The &quot;Last updated&quot; date will always indicate the
          latest revision.
        </p>

      </div>
    </div>
  );
}
